import { FinalImpactScoreType, NetScoreFormat } from '@upright/common/model/output/scores/types';

export const getAvailableAggregateMetrics = (scoreUnit: FinalImpactScoreType | undefined) => {
  switch (scoreUnit) {
    default:
      return [NetScoreFormat.NET_RATIO, NetScoreFormat.NET_SUM];
  }
};

export const getDefaultAggregateMetric = (scoreUnit: FinalImpactScoreType | undefined) => {
  switch (scoreUnit) {
    default:
      return NetScoreFormat.NET_RATIO;
  }
};

export function scoreTypeTitle(netScoreFormat: NetScoreFormat) {
  if (netScoreFormat !== NetScoreFormat.NET_SUM) {
    return 'Net impact ratio';
  }

  return 'Net impact sum';
}

export type AggregateMetricProps = {
  setAggregateMetric?: (newFormat: NetScoreFormat) => void;
  availableMetrics?: NetScoreFormat[];
  currentMetric: NetScoreFormat;
};
